"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerBackgroundTabDetection = registerBackgroundTabDetection;

var _core = require("@sentry/core");

var _debugBuild = require("../debug-build.js");

var _helpers = require("../helpers.js");

/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (_helpers.WINDOW && _helpers.WINDOW.document) {
    _helpers.WINDOW.document.addEventListener('visibilitychange', () => {
      const activeSpan = (0, _core.getActiveSpan)();

      if (!activeSpan) {
        return;
      }

      const rootSpan = (0, _core.getRootSpan)(activeSpan);

      if (_helpers.WINDOW.document.hidden && rootSpan) {
        const cancelledStatus = 'cancelled';

        const _spanToJSON = (0, _core.spanToJSON)(rootSpan),
              op = _spanToJSON.op,
              status = _spanToJSON.status;

        if (_debugBuild.DEBUG_BUILD) {
          _core.logger.log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
        } // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.


        if (!status) {
          rootSpan.setStatus({
            code: _core.SPAN_STATUS_ERROR,
            message: cancelledStatus
          });
        }

        rootSpan.setAttribute('sentry.cancellation_reason', 'document.hidden');
        rootSpan.end();
      }
    });
  } else {
    _debugBuild.DEBUG_BUILD && _core.logger.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}